import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { useQuery } from "@apollo/client";
import { Loader } from "semantic-ui-react";
import ItemHeader from "../ItemHeader";
import useRoute from "/imports/client/router/useRoute";
import { GET_INVOICE } from "/imports/client/views/invoice/utils/queries";
import { formattedCurrencyValue } from "../../tags/CurrencyTag";

import Debug from "debug";
const debug = Debug("header");

const FALLBACK_STATUS = "pending";
const FALLBACK_NUMBER = "N/A";
const FALLBACK_AMOUNT = "N/A";
const FALLBACK_VENDOR = "N/A";

const InvoiceHeader = () => {
  const { t } = useTranslation();
  const { params } = useRoute();
  const invoiceId = params._id;

  const { data = {}, loading: isLoading, error } = useQuery(GET_INVOICE, {
    variables: { invoiceId }
  });

  debug("header query %o", { data, isLoading, error });

  const invoice = data.invoice || {};
  return (
    <ItemHeader>
      {isLoading ? (
        <Loader active inline size="tiny" />
      ) : (
        <div className="main">
          <div>{t("invoice:header.title")}</div>
          <div className="meta center">
            <Trans
              i18nKey="invoice:header.number"
              values={{ value: invoice?.number || FALLBACK_NUMBER }}
            />
          </div>
          <div className="meta center">
            <Trans
              i18nKey="invoice:header.seller"
              values={{ value: invoice?.seller?.name || FALLBACK_VENDOR }}
            />
          </div>
          <div className="meta center">
            <Trans
              i18nKey="invoice:header.amount"
              values={{
                value: invoice?.amount ? formattedCurrencyValue(invoice.amount) : FALLBACK_AMOUNT
              }}
            />
          </div>
          <div className="meta center">
            <Trans
              i18nKey="invoice:header.status"
              values={{ value: invoice?.status || FALLBACK_STATUS }}
            />
          </div>
        </div>
      )}
    </ItemHeader>
  );
};

export default InvoiceHeader;
